"use strict";

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskySelectAutocomplete = void 0;

const react_1 = __importDefault(require("react"));

const material_1 = require("@mui/material");

const SskySelectAutocomplete = props => {
  const {
    dataTestId,
    label,
    helperText,
    placeholder,
    inputDataTestId,
    className,
    onChange,
    getOptionLabel,
    renderInput,
    onBlur
  } = props,
        additionalProps = __rest(props, ["dataTestId", "label", "helperText", "placeholder", "inputDataTestId", "className", "onChange", "getOptionLabel", "renderInput", "onBlur"]);

  const handleChange = (e, value, reason) => {
    if (!onChange) return;
    Array.isArray(value) ? onChange(e, value, reason) : onChange(e, [value], reason);
  };

  const renderDefaultTextField = params => react_1.default.createElement(material_1.TextField, Object.assign({}, params, {
    label: label,
    placeholder: placeholder,
    InputLabelProps: label && placeholder ? {
      shrink: true
    } : {},
    helperText: helperText,
    "data-testid": inputDataTestId,
    onBlur: onBlur,
    variant: "standard"
  }));

  return react_1.default.createElement(material_1.Autocomplete, Object.assign({}, additionalProps, {
    disableCloseOnSelect: additionalProps.multiple,
    getOptionLabel: getOptionLabel ? getOptionLabel : option => option.display,
    renderInput: renderInput ? renderInput : renderDefaultTextField,
    onChange: handleChange,
    "data-testid": dataTestId,
    className: className
  }));
};

exports.SskySelectAutocomplete = SskySelectAutocomplete;
exports.default = SskySelectAutocomplete;